<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">

      <slide>
        <div class="padding">
          <p>It felt as if the rain got lighter today, and the water levels are definitely lowering. I could see the highest branches of the old oak trees poking above the surface near the entrance to the flowtunnels . . spring is coming</p>
<br>
          <p>I didn't need to pick up Oska until later, so I stayed in town but had nothing to buy or trade, i decided to just spend the afternoon walking. I wandered along Four-head Way, sometimes stopping to just watch people pass me. I could see the change in the weather in everyone's step, a lightness of movement, more smiles.</p>
<br>
          <p>The crowds seemed to move with a singular purpose towards the old glass hall. There was an emarket happening nearby and i followed along. I could already smell the harse wraps before I got in the hall, their scent clear through the damp air, from the next hall I heard discordant voices sing out as a voicering started up, but the raindrops had hardly finished running off the seals of my coat before I knew that today this was too crowded for me, I needed to get outside.</p>
<br>
          <p>I pushed my way through the traders, the words being exchanged just a wash of noise that dropped away the moment I stepped outside and stopped on the plaza. I looked down at the ripples in the puddle around my feet, and in the reflection I saw the clock on the front of the hall. I stared at it for a moment, and I was struggling so hard to read the time in reverse that it was only a few moments later that I remembered the hall clock is actually on the other side of the building.</p>
<br>
          <p>I looked up and tried to spot which clock i'd seen reflected, but couldn't work it out. I tried to find it in the water again but my movement disturbed it so much I couldn't find the right angle.</p>
<br>
          <p>I walked away, but became much more aware of my pace, cyclists sped past me but I moved slowly, somehow at the speed of my soul. I listened to the sound my feet make as they hit the ground, sometimes in water, sometimes in hard stone. I wondered if i pressed down hard would I leave an impression, something others could follow?</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'Ripple'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
